// @format
import React from 'react';
import styled from 'styled-components';
import colors from '../constants/colors';

const ItemTitle = ({ children }) => (
  <ItemTitleWrapper>
    <div>{children}</div>
  </ItemTitleWrapper>
);

const ItemTitleWrapper = styled.div`
  display: flex;
  align-items: center;
  vertical-align: middle;
  width: 100%;
  height: 34px;
  font-size: 16px;
  font-weight: bold;
  color: white;
  background-color: ${colors.RED};
  padding-left: 16px;
  padding-right: 16px;
  vertical-align: middle;
  box-sizing: border-box;
`;

const ClickWrapper = styled.a`
  display: block;
  color: ${colors.RED};
  background: linear-gradient(#dae6e3, #bdd2d0);
  padding-top: 12px;
  padding-left: 16px;
  padding-right: 16px;
  padding-bottom: 24px;
  cursor: pointer;
  font-weight: bold;
  box-sizing: border-box;
  text-decoration: none;
`;

const ItemWrapper = styled.div`
  flex-grow: 1;
  /* min-width: 275px; */
  padding-left: 6px;
  padding-right: 6px;

  &:first-child {
    padding-left: 0;
  }
  &:last-child {
    padding-right: 0;
  }

  @media (max-width: 1100px) {
    position: realtive;
    width: 100%;
    padding: 0;
    padding-bottom: 12px;
  }
`;

export default ({ children, pdf, enrollment, trust }) => (
  <ItemWrapper>
    <ItemTitle>{children}</ItemTitle>
    <ClickWrapper
      href={`/view${enrollment ? '/enrollment' : ''}${
        trust ? '/trust' : ''
      }?url=${process.env.PUBLIC_URL}/${encodeURIComponent(pdf)}`}
    >
      Click here for more details
    </ClickWrapper>
  </ItemWrapper>
);
